import React,{useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
                                    

export default function ScheduleCardHeader(param) {

    const [programId, setProgramId] = useState("");

    useEffect(() => {
        setProgramId(param.programId);
    }, [param.programId])

    function contentCheckButton(value) {
        param.callbackWrapperCheck(true);
        param.callbackContentCheckButton(value);
    }

    return(
        <div className="card-header contentColor">
            <h3 className="card-title">스케줄 조회</h3>
            <div className="card-header-image">
                {
                    programId !== "" &&
                        <div className="float-right">
                            <ul className="nav nav-pills">
                                <li className="nav-item dropdown">
                                    <a href="" className="dropdown-toggle" data-toggle="dropdown">
                                        <i className="fas fa-plus"></i> 새 스케줄 등록
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-create-right">
                                        <button className="btn w-100 " onClick={() => contentCheckButton("message")} data-toggle="tooltip" title="새 콘텐츠 등록" > 메시지 등록</button>
                                        <div className="dropdown-divider"></div>
                                        <button className="btn w-100" onClick={() => contentCheckButton("content")} data-toggle="tooltip" title="새 콘텐츠 등록" > 컨텐츠 등록</button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                }
            </div>
        </div>
        
    );
}

ScheduleCardHeader.propTypes = {
    programId: PropTypes.any
  };